import { Link } from "react-router-dom";
import { LogOut, Sparkles, UserRound, LayoutDashboard } from "lucide-react";
import { useDemoMode } from "../../context/DemoModeContext";
import { DEMO_BANNER_HEIGHT_PX } from "../../constants/layout";

export default function DemoBanner() {
  const {
    isDemoSession,
    logout,
    demoClientEnabled,
    demoAdminEnabled,
  } = useDemoMode();
  if (!isDemoSession) return null;

  return (
    <div
      className="fixed left-0 right-0 top-0 z-[52] flex shrink-0 items-stretch border-b border-white/[0.12] bg-[linear-gradient(105deg,#0a0628_0%,#190276_42%,#120a4a_100%)] shadow-[0_4px_24px_rgba(8,4,40,0.45)] backdrop-blur-sm"
      style={{ height: DEMO_BANNER_HEIGHT_PX, minHeight: DEMO_BANNER_HEIGHT_PX }}
      role="status"
    >
      <div
        className="pointer-events-none absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#F2B531]/70 to-transparent"
        aria-hidden
      />
      <div className="flex w-full max-w-[min(100%,1760px)] mx-auto items-center justify-between gap-2 px-3 sm:gap-4 sm:px-6">
        <div className="flex min-w-0 flex-1 items-center gap-2 sm:gap-3">
          <div
            className="flex h-8 w-8 shrink-0 items-center justify-center rounded-xl bg-white/[0.08] ring-1 ring-white/15 shadow-inner"
            aria-hidden
          >
            <Sparkles className="h-4 w-4 text-[#F2B531]" strokeWidth={2} />
          </div>
          <div className="min-w-0 py-1">
            <p className="text-[10px] font-bold uppercase tracking-[0.22em] text-white/95 sm:text-[11px] sm:tracking-[0.28em]">
              Espace de démonstration privé
            </p>
            <p className="hidden truncate text-[10px] leading-tight text-white/60 sm:block sm:text-[11px]">
              Version de présentation — certaines actions sont désactivées pour préserver la démo.
            </p>
          </div>
        </div>

        <div className="flex shrink-0 items-center gap-1 sm:gap-2">
          {demoClientEnabled && (
            <Link
              to="/connexion"
              className="inline-flex items-center gap-1 rounded-lg border border-white/20 bg-white/[0.07] px-2 py-1.5 text-[10px] font-semibold text-white transition-colors hover:bg-white/15 sm:gap-1.5 sm:px-3 sm:text-[11px]"
            >
              <UserRound className="h-3.5 w-3.5 opacity-90" strokeWidth={2} aria-hidden />
              <span className="hidden sm:inline">Compte client démo</span>
              <span className="sm:hidden">Client</span>
            </Link>
          )}
          {demoAdminEnabled && (
            <Link
              to="/admin"
              className="inline-flex items-center gap-1 rounded-lg border border-[#F2B531]/35 bg-[#F2B531]/10 px-2 py-1.5 text-[10px] font-semibold text-[#F2F0FF] transition-colors hover:bg-[#F2B531]/18 sm:gap-1.5 sm:px-3 sm:text-[11px]"
            >
              <LayoutDashboard className="h-3.5 w-3.5 text-[#F2B531]" strokeWidth={2} aria-hidden />
              <span className="hidden sm:inline">Admin démo</span>
              <span className="sm:hidden">Admin</span>
            </Link>
          )}
          <button
            type="button"
            onClick={() => logout()}
            className="inline-flex items-center gap-1 rounded-lg border border-white/15 px-2 py-1.5 text-[10px] font-semibold uppercase tracking-wide text-white/90 transition-colors hover:bg-white/10 sm:px-2.5 sm:text-[11px]"
          >
            <LogOut className="h-3 w-3" aria-hidden />
            <span className="hidden sm:inline">Quitter</span>
          </button>
        </div>
      </div>
    </div>
  );
}
